/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InventoryPeriodDTO
 */
export interface InventoryPeriodDTO {
    /**
     * 
     * @type {Date}
     * @memberof InventoryPeriodDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof InventoryPeriodDTO
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof InventoryPeriodDTO
     */
    initDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryPeriodDTO
     */
    periodActive?: boolean;
}

/**
 * Check if a given object implements the InventoryPeriodDTO interface.
 */
export function instanceOfInventoryPeriodDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InventoryPeriodDTOFromJSON(json: any): InventoryPeriodDTO {
    return InventoryPeriodDTOFromJSONTyped(json, false);
}

export function InventoryPeriodDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryPeriodDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'initDate': !exists(json, 'initDate') ? undefined : (new Date(json['initDate'])),
        'periodActive': !exists(json, 'periodActive') ? undefined : json['periodActive'],
    };
}

export function InventoryPeriodDTOToJSON(value?: InventoryPeriodDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'id': value.id,
        'initDate': value.initDate === undefined ? undefined : (value.initDate.toISOString()),
        'periodActive': value.periodActive,
    };
}

